"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.settings.title': 'Configuración de Chat',
    'chat.settings.media_generation': 'Generación de Medios',
    'chat.settings.image_model': 'Modelo de Imagen',
    'chat.settings.video_model': 'Modelo de Video',
    'chat.settings.voice.label': 'Voz',
    'chat.settings.chat_learning.label': 'Aprender sobre el usuario de la conversación del chat',
    'chat.settings.chat_learning.description': 'El sistema analizará sus conversaciones de vez en cuando y ajustará su estilo de respuesta a la forma en que interactúa con el sistema',
    'chat.settings.enable_ai_assistant.label': 'Habilitar Asistente IA',
    'chat.settings.enable_ai_assistant.description': 'Habilite el Asistente IA para proporcionar sugerencias inteligentes y ayuda durante sus conversaciones',
    'chat.settings.enable_ai_assistant.disabled_tooltip': 'El Asistente IA no está disponible con su plan actual. Por favor, actualice para acceder a esta función.',
    'chat.settings.save': 'Guardar',
    'chat.settings.saved': 'Configuración guardada exitosamente',
    'chat.settings.ai_parameters': 'Parámetros de IA',
    'chat.settings.temperature.label': 'Temperatura',
    'chat.settings.temperature.description': 'Controla la aleatoriedad en las respuestas de IA. Valores más bajos hacen las respuestas más enfocadas y determinísticas, valores más altos las hacen más creativas y variadas.',
    'chat.settings.temperature.min_label': 'Estricto',
    'chat.settings.temperature.max_label': 'Creativo',
    'chat.settings.assistance_setup': 'Configuración de Asistencia',
    'chat.settings.max_tokens.label': 'Longitud de Respuesta',
    'chat.settings.max_tokens.description': 'Controla la longitud máxima de las respuestas de IA. Por defecto usa la configuración del modelo, otras opciones limitan la longitud de respuesta.',
    'chat.settings.max_tokens.default': 'Por Defecto (Configuración del Modelo)',
    'chat.settings.max_tokens.short': 'Corta',
    'chat.settings.max_tokens.medium': 'Mediana',
    'chat.settings.max_tokens.long': 'Larga',
    'chat.settings.extended_context.label': 'Contexto Extendido',
    'chat.settings.extended_context.description': 'Habilitar el modo de contexto extendido para mantener una memoria de conversación más larga y una mejor comprensión de mensajes anteriores',
    'chat.settings.thinking.label': 'Habilitar Pensamiento',
    'chat.settings.thinking.description': 'Mostrar el razonamiento de la IA y el proceso de pensamiento durante la generación de respuestas',
};
